import { RuleOperationType, RuleTypes } from './models';

export const getArrayCriterias = (criterias: {
  rule: {
    rules: any[];
    operationType: RuleOperationType;
  };
}) => {
  const result: any[] = [];
  if (criterias.rule.operationType === RuleOperationType.Or) {
    result.push(
      ...(criterias.rule.rules || []).map((rule: { [key: string]: string }) => ({
        ...rule,
        nextOperation: RuleOperationType.Or,
      })),
    );
  } else if (criterias.rule.operationType === RuleOperationType.And) {
    result.push(
      ...(criterias.rule.rules || []).flatMap(
        (rule: { criteriaRuleType: string; rules: any[]; operationType: string }) => {
          return rule.criteriaRuleType === RuleTypes.CriteriaRuleGroup
            ? rule.rules.map((ruleInGroup: { operationType: any }, indexGroup, arrGroup) => ({
                ...ruleInGroup,
                nextOperation: indexGroup === arrGroup.length - 1 ? RuleOperationType.And : rule.operationType,
              }))
            : {
                ...rule,
                nextOperation: RuleOperationType.And,
              };
        },
      ),
    );
  } else result.push(criterias.rule);
  result.at(-1).nextOperation = '';
  return result;
};
